import { render, staticRenderFns } from "./ResourceScheduleFields.vue?vue&type=template&id=40e48512&scoped=true&lang=pug&"
import script from "./ResourceScheduleFields.vue?vue&type=script&lang=js&"
export * from "./ResourceScheduleFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e48512",
  null
  
)

export default component.exports